import React from 'react';

//styling
import '../containers/Signup.css';

const MustContainItem = (props) => {
  const { data } = props;
  const label = data[0];
  const meetsReq = data[1];

  return (
    <div className={"MustContainItem"}>
      <div className="must-item">
        <li className={`must-text ${meetsReq ? 'text-success' : 'none'}`}>{label}</li>
      </div>
    </div>
  );
};

export default MustContainItem;
